export default __webpack_public_path__ + "138981077538e3525d65a54f941ed563.png";